import createIcon from '../../createIcon';

/**
 * @component @name Build
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuNzI3OCAxOC45NTAxTDEzLjYyNzggOS44NTAwOUMxNC41Mjc4IDcuNTUwMDkgMTQuMDI3OCA0Ljg1MDA5IDEyLjEyNzggMi45NTAwOUMxMC4xMjc4IDAuOTUwMDg1IDcuMTI3NzcgMC41NTAwODUgNC43Mjc3NyAxLjY1MDA5TDkuMDI3NzcgNS45NTAwOUw2LjAyNzc3IDguOTUwMDlMMS42Mjc3NyA0LjY1MDA5QzAuNDI3NzcxIDcuMDUwMDkgMC45Mjc3NzEgMTAuMDUwMSAyLjkyNzc3IDEyLjA1MDFDNC44Mjc3NyAxMy45NTAxIDcuNTI3NzcgMTQuNDUwMSA5LjgyNzc3IDEzLjU1MDFMMTguOTI3OCAyMi42NTAxQzE5LjMyNzggMjMuMDUwMSAxOS45Mjc4IDIzLjA1MDEgMjAuMzI3OCAyMi42NTAxTDIyLjYyNzggMjAuMzUwMUMyMy4xMjc4IDE5Ljk1MDEgMjMuMTI3OCAxOS4yNTAxIDIyLjcyNzggMTguOTUwMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Build = createIcon('Build', [
  [
    'path',
    {
      d: 'M22.7278 18.9501L13.6278 9.85009C14.5278 7.55009 14.0278 4.85009 12.1278 2.95009C10.1278 0.950085 7.12777 0.550085 4.72777 1.65009L9.02777 5.95009L6.02777 8.95009L1.62777 4.65009C0.427771 7.05009 0.927771 10.0501 2.92777 12.0501C4.82777 13.9501 7.52777 14.4501 9.82777 13.5501L18.9278 22.6501C19.3278 23.0501 19.9278 23.0501 20.3278 22.6501L22.6278 20.3501C23.1278 19.9501 23.1278 19.2501 22.7278 18.9501Z',
      key: '1n53vw',
    },
  ],
]);

export default Build;
